const APP_ACCESS_STORAGE_KEY = 'mms_appAccess';

/**
 * @returns {Object|null} Cached access flags, or null if not available
 */
export function loadCachedAppAccess() {
  try {
    const cached = localStorage.getItem(APP_ACCESS_STORAGE_KEY);
    if (!cached) return null;
    const parsed = JSON.parse(cached);
    if (typeof parsed === 'object' && parsed !== null && 'broadcast' in parsed) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}

/**
 * @param {Object} access - Access flags object to persist
 */
export function saveAppAccess(access) {
  try {
    localStorage.setItem(APP_ACCESS_STORAGE_KEY, JSON.stringify(access));
  } catch { /* quota exceeded or private mode */ }
}

/**
 * @param {Array} applications - Array of application objects with applicationName property
 * @returns {Object} Object with access flags for each app
 */
export function getAppAccessFromApplications(applications) {
  if (!applications || !Array.isArray(applications)) {
    return {
      broadcast: false,
      'online-video': false,
      'cross-platform': false,
      'video-in-home': false,
      portal: true
    };
  }

  return {
    // Broadcast (TV-analys): any application containing "tv-analys"
    broadcast: applications.some(app =>
      app.applicationName && app.applicationName.includes('tv-analys')
    ),

    // Online Video: any application containing "online"
    'online-video': applications.some(app =>
      app.applicationName && app.applicationName.includes('online')
    ),

    // Cross Platform (Total-analys): exact match for "total-analys"
    'cross-platform': applications.some(app =>
      app.applicationName === 'total-analys'
    ),

    // Video In Home: exact match for "video-in-home"
    'video-in-home': applications.some(app =>
      app.applicationName === 'video-in-home'
    ),

    // Portal: always accessible
    portal: true
  };
}
